import PersonModal from './personmodal.jsx'

export default PersonModal
